import { render, staticRenderFns } from "./TableTeams.vue?vue&type=template&id=61ffbf2c"
import script from "./TableTeams.js?vue&type=script&lang=js&external"
export * from "./TableTeams.js?vue&type=script&lang=js&external"
import style0 from "./TableTeams.vue?vue&type=style&index=0&id=61ffbf2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports